import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { PageContainer } from "@/components/flowly/PageContainer/PageContainer";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/utils";
import { FAQ_ITEMS } from "./constants";
import { FAQItem } from "./FAQItem";

export function FAQSection() {
  const { t } = useLanguage();
  const { ref, isInView } = useInView();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="py-20 md:py-28 bg-muted/30">
      <PageContainer width="content">
        <div
          ref={ref}
          className={cn(
            "transition-all duration-700",
            isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
          )}
        >
          {/* Header */}
          <div className="text-center mb-12">
            <span className="block text-xs font-semibold tracking-[0.2em] uppercase text-brand mb-3">
              {t.landing.eyebrowFaq}
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              {t.landing.faqTitle}
            </h2>
          </div>

          {/* FAQ Items */}
          <div className="max-w-3xl mx-auto">
            {FAQ_ITEMS.map((item, index) => {
              const question =
                t.landing[item.questionKey as keyof typeof t.landing];
              const answer =
                t.landing[item.answerKey as keyof typeof t.landing];

              return (
                <FAQItem
                  key={item.questionKey}
                  question={question}
                  answer={answer}
                  isOpen={openIndex === index}
                  onToggle={() => handleToggle(index)}
                />
              );
            })}
          </div>
        </div>
      </PageContainer>
    </section>
  );
}
